import { useEffect } from "react"
import { useMainTemplateContext } from "../context"

// HOOK
export default function useMainTemplate(options: Options = {}, deps: any[] = []) {
    const { setCategory } = useMainTemplateContext()

    useEffect(() => {
        if (options.category) setCategory(options.category)
    }, deps)
}

interface Options {
    category?: string
}